<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    title="编辑用户"
    :visible.sync="dialogFormVisible"
    @closed="closed"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="客服姓名"
        :label-width="formLabelWidth"
        prop="servicePersonName"
      >
        <el-select
          class="select"
          v-model="editForm.customerServiceId"
          filterable
          remote
          placeholder="请输入客服姓名"
          :remote-method="searchUser"
          @change="checkServicePerson"
          clearable
          @clear="editForm.customerServiceId = ''"
          :loading="loading"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="租购意向"
        :label-width="formLabelWidth"
        prop="servicePersonName"
      >
        <el-radio-group v-model="editForm.isSale">
          <el-radio :label="false">租赁</el-radio>
          <el-radio :label="true">购买</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { modifyCustomerService } from '@/api/introduce';
import { decrypt } from '@/utils/encryp';
// import { getToken } from '@/utils/token.js'
export default {
  name: 'ChangeStatus',
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      userOptions: [],
      loading: false,
      // 编辑表单
      editForm: {
        id: '',
        customerServiceId: '',
        isSale: false,
      },
      // 表单的验证规则
      editRules: {
        customerServiceId: [
          { required: true, message: '请选择客服人员！', trigger: 'blur' },
        ],
      },
    };
  },

  mounted() {},
  methods: {
    // 提交按钮
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return;
          const areaId = localStorage.getItem('areaId')
            ? JSON.parse(localStorage.getItem('areaId')).areaId
            : '';
          modifyCustomerService({ ...this.editForm, areaId }).then((res) => {
            if (res.code == 200) {
              this.$message.success('修改成功！');
              this.dialogFormVisible = false;
              this.closed();
              this.$emit('fetchData');
            } else {
              this.$message.error(this.res.message);
            }
          });
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 关闭时的回调
    closed() {
      this.$refs.editForm.resetFields();
      this.editForm.id = '';
      this.editForm.customerServiceId = '';
    },
    // 搜索用户名
    async searchUser(val, id = '') {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.userOptions = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
      // 初始化匹配 -- 传值过来
      if (!id) return;
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择客户下拉选项
    checkServicePerson(val) {
      this.editForm.customerServiceId = val;
    },
  },
  created() {},
};
</script>

<style lang="less" scoped></style>
